import React from 'react';
import SiderBar from './components/Siderbar';
import ProfileInfo from './components/ProfileInfo';
import Notification from './components/Notification';
function Profile() {
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-md-3 col-12">
                    <SiderBar />
                </div>
                <div className="col-lg-5 col-md-5 col-12">
                    <ProfileInfo />
                </div>
                <div className="col-lg-4 col-md-4 col-12">
                    <Notification />
                </div>
            </div>
        </div>
    );
}
export default Profile;